import styled from 'styled-components';
import { grid, layout, LayoutProps, GridProps } from 'styled-system';

export type ContainerProps = GridProps & LayoutProps & Record<string, any>;

export const Container = styled.div<ContainerProps>(layout, grid);
